{
  "appName": "Discover Your Benefits",
  "entryFile": "./app-entry.jsx",
  "entryName": "discover-your-benefits",
  "rootUrl": "/discover-your-benefits",
  "productId": "87f2c91f-46c3-4461-8890-3636130af4ab"
}
